module.exports = __webpack_public_path__ + "media/images/illustrations/clock_large-cad2fe1f4ee9b346de37b00b9f582454.svg";